import { DenominationCategoryType } from '../model/denomination.types'

export const getDenominationCategories = (
  denominations: Array<{ features?: { subcategory?: string; iconsubcategory?: string } }>
) => {
  const uniqueDenominationCategories = denominations?.reduce<Record<string, DenominationCategoryType>>(
    (acc, denomination) => {
      const { subcategory, iconsubcategory } = denomination?.features || {}

      if (!subcategory || !iconsubcategory) {
        return acc
      }

      const key = `${subcategory}|${iconsubcategory}`

      if (!acc[key]) {
        acc[key] = { icon: iconsubcategory, label: subcategory }
      }

      return acc
    },
    {}
  )

  return Object.values(uniqueDenominationCategories ?? {})
}
